import styled from "styled-components";
import {
  TituloH1 as TituloPrincipal,
  Descricao,
} from "../../../../components/TituloSorriso/styles";

export const Container = styled.div`
  min-height: 350px;
  display: flex;
  padding-top: 70px;
  align-items: flex-start;
  background: #d9dcdd;

  @media (max-width: 1024px) {
    flex-direction: column;
    flex-flow: column-reverse;

    align-items: center;
    padding: 70px !important;
    gap: 15px;
  }

  @media (max-width: 767px) {
    align-items: center;
    min-height: 325px;
    padding: 32px !important;
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  max-width: min-content;
`;

export const Title = styled(TituloPrincipal)`
  color: #0e1e64;
  text-align: left !important;
  line-height: 45px;
  font-size: 30px;
  font-weight: 600;
  padding-right: 165px;
  padding-bottom: 16px;
  padding-top: 0;

  @media (max-width: 767px) {
    padding-right: 0;
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
  }
`;

export const Text = styled(Descricao)``;

export const Image = styled.img`
  position: relative;
  flex: 1;
  top: -17px;

  @media (max-width: 767px) {
    top: 0;
    max-width: 288px;
  }
`;
